// extracted by mini-css-extract-plugin
export default {"hidden":"OGFMUf","link":"jO8UmJ","active":"C2MFpe","svg":"p2pxTG","prev":"ZyvthZ","link-active":"XHnX6j","linkActive":"XHnX6j"};